/* eslint-disable camelcase */
import { addEnvelopeToSavedSearch } from 'actions';
import Permissions from 'components/Permissions';
import ReviewSetSelect from 'components/ReviewSets/ReviewSetSelect';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSelectedCommunication } from 'selectors/communications';
import getSelectedEnvelope, {
  getOriginalCommunication,
  getSummaryTag,
  getTranslationCommunication,
} from 'selectors/envelopeReview';
import { getOpenAttachmentState } from 'selectors/envelopeView';
import { useSelector } from 'store';
import { CommunicationWithEvents, SavedSearch } from 'types';
import { isFileCommunication } from 'utils/communications';
import EnvelopeTranslation from './EnvelopeTranslation';
import SummaryTag from './SummaryTag';

type ComponentProps = {
  communication: CommunicationWithEvents;
};

const CommunicationContentHeader: React.FC<ComponentProps> = ({ communication }) => {
  const dispatch = useDispatch();

  const params = useParams<{ envelopeId?: string }>();
  const isEnvelopePage = !!params?.envelopeId;

  const openAttachment = useSelector(getOpenAttachmentState);
  const selectedCommunication = useSelector(getSelectedCommunication);

  const parentId = selectedCommunication?.meta_data?.parent_communication_uuid ?? '';
  const envelopeTranslation = useSelector((state) =>
    getTranslationCommunication(state, openAttachment)
  );
  const originalCommunication = useSelector((state) => getOriginalCommunication(state, parentId));
  const selectedEnvelope = useSelector(getSelectedEnvelope);

  const showingTranslation = selectedCommunication?.uuid === envelopeTranslation?.uuid;
  const summaryTag = useSelector((state) => getSummaryTag(state, communication?.uuid || ''));
  const isFile = isFileCommunication(selectedCommunication);

  const handleSelectReviewSet = (reviewSet: SavedSearch): void => {
    if (selectedEnvelope) {
      dispatch(addEnvelopeToSavedSearch({ envelope: selectedEnvelope, savedSearch: reviewSet }));
    }
  };

  if (
    !isEnvelopePage &&
    summaryTag === 'none' &&
    ((showingTranslation && !originalCommunication) ||
      (!showingTranslation && !envelopeTranslation))
  ) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <EnvelopeTranslation />

      <div className="flex flex-row justify-between">
        <SummaryTag type={summaryTag} />
        {!isFile && isEnvelopePage && (
          <Permissions action="reviewSets.appendEnvelope">
            <ReviewSetSelect selectReviewSet={handleSelectReviewSet} />
          </Permissions>
        )}
      </div>
    </div>
  );
};

export default CommunicationContentHeader;
